import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {Address} from '../../../../addresses/models/address.model';
import {LocationType} from '../../../../commons/types/location.type';
import {ServicePointModel} from '../../../../service-points/angular/models/service-point.model';
import {UI_CUSTOM_ADDRESS_TYPE, UI_SERVICE_POINT_TYPE} from '../../utils/availability-location-settings.util';

require('./availability-location-point.scss');
@Component({
  standalone: false,
  selector: 'app-availability-location-point',
  templateUrl: './availability-location-point.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvailabilityLocationPointComponent {

  @Input() label: string;
  @Input() pointType: string;
  @Input() homeDisplay: string;
  @Input() servicePointId: string;
  @Input() servicePointPlace: string;
  @Input() customAddress: Address;

  @Output() onPointTypeChange = new EventEmitter<string>();
  @Output() onServicePointChange = new EventEmitter<ServicePointModel | null>();
  @Output() onCustomAddressChange = new EventEmitter<Address | undefined>();

  public locationTypeCustom = LocationType.CUSTOM;
  public servicePointType = UI_SERVICE_POINT_TYPE;
  public customAddressType = UI_CUSTOM_ADDRESS_TYPE;

}
